<p-toast [baseZIndex]="1000" position="top-left"></p-toast>
<p-confirmDialog [style]="{width: '50vw'}"></p-confirmDialog>
<div class="container-fluid">
  <form [formGroup]="entidadeForm" autocomplete="off">
  <div class="card-panel mt-5">
      <div class="row">
        <div class="col-md-6">
          <lib-page-header page-title="CRÉDITOS ADICIONAIS"
            page-subtitle="EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
            image-title="assets/img/money4.png">
          </lib-page-header>
        </div>
        <div class="col-md-6">
          <a (click)="voltar()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </a>
          <a [routerLink]="['/creditos']" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
          <button (click)="submitForm()" type="submit"
            class="btn btn-outline-info float-right mr-4" style="font-size: 13px">Salvar crédito</button>
        </div>
      </div>
      <hr class="mt-0 mb-4" />
      <div class="row mb-4">
        <div class="col-md-12">
          <div class="row">
            <div class="form-group col-md-4">
              <label for="selectTipo">Tipo de crédito<span class="text-danger">*</span></label>
              <select #myInput id="selectTipo" formControlName="tipo" class="custom-select">
                <option [value]="item.id" *ngFor="let item of listaTipos">
                  {{item.nome}}
                </option>
              </select>
            </div>
            <div class="form-group col-md-8">
              <label for="selectOco">Ocorrência<span class="text-danger">*</span></label>
              <select name="selectOco" formControlName="ocorrencia" class="custom-select font-weight-bold">
                <option [value]="item.id" *ngFor="let item of listaOcorrencias">
                  {{item.nome}}
                </option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-2">
              <label for="data_credito">Data<span class="text-danger">*</span></label>
              <p-calendar id="data_credito" formControlName="data_credito" inputStyleClass="form-control"
                dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false"
                [showButtonBar]="true" [style]="{ width: '100%' }">
              </p-calendar>
            </div>
            <div class="form-group col-md-2">
              <label for="data_publica">Publicação<span class="text-danger">*</span></label>
              <p-calendar id="data_publica" formControlName="data_publicacao" inputStyleClass="form-control"
                dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false"
                [showButtonBar]="true" [style]="{ width: '100%' }">
              </p-calendar>
            </div>
            <div class="form-group col-md-3">
              <label for="dec">Decreto N˚<span class="text-danger">*</span></label>
              <p-inputMask id="dec" formControlName="decreto" mask="9999/9999" slotChar=" " styleClass="form-control">
              </p-inputMask>
            </div>
            <div class="form-group col-md-3">
              <label for="lei">Lei N˚<span class="text-danger">*</span></label>
              <p-inputMask id="lei" formControlName="lei" mask="9999/9999" slotChar=" " styleClass="form-control">
              </p-inputMask>
            </div>
            <div class="form-group col-md-2">
              <label for="data_vigencia">Vigência<span class="text-danger">*</span></label>
              <p-calendar id="data_vigencia" formControlName="data_vigencia" inputStyleClass="form-control"
                dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false"
                [showButtonBar]="true" [style]="{ width: '100%' }">
              </p-calendar>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-12">
              <label for="justificativa">Justificativa<span class="text-danger">*</span></label>
              <textarea formControlName="justificativa" class="form-control" id="justificativa" rows="4"></textarea>
            </div>
          </div>

        </div>
      </div>

      <app-credito-item [(lista)]="listaCreditoItens" [(entidade)]="entidade" [login]="login">
      </app-credito-item>

    </div>
    <br>
    <br>
    <br>
    <br>
    <div id="footer" class="row mt-4">
      <div class="offset-1 col-11 ml-5 pl-3 pt-3 mb-3">
        <button (click)="submitForm(true)" class="btn btn-sm btn-secondary">
          <img src="assets/img/global/tick.png" alt="cvs" title="" height="20" width="20">
          Salvar e novo
        </button>
      </div>
    </div>
  </form>
</div>
